import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { formateDateTime } from '../../../utils/commonFunctions';
import { tableEditIcon } from '../../../assets/images';
import { CircularAvatar } from '../../commons';
type AppProps = {
    data: any;
    tableHeader: TableHeadersType[];
    handleEditMasterClientGroup: any;
    isClientGroupEditButtonPresent:boolean;
}
const ClientGroupTableData = ({
    data,
    tableHeader,
    handleEditMasterClientGroup,
    isClientGroupEditButtonPresent
}: AppProps) => {
    return (
        <>{
            data && data?.length > 0 && data?.map((itemData: any) => {
                const assignedClient=itemData?.mapped_client;
                return <tr key={itemData?._id}>
                    {
                        tableHeader?.map((item: TableHeadersType) => {
                            if (item?.value === "client_group_name") {
                                return <td>{itemData?.client_group_name}</td>
                            }
                            else if (item?.value === 'mapped_client') {
                                return <td className='text-start' style={{ minWidth: "200px" }}>
                                {assignedClient?.length?assignedClient?.map((e: any) => <div className='d-flex justify-content-sm-start mb-1 ml-2'>
                                  <CircularAvatar name={e?.name} image={e?.profile_pic?.file_url} /><span style={{ marginLeft: "10px", marginTop: "2px" }}>{e?.name}{`(${e?.code})`}</span>
                                </div>):"--/--"}
                                </td>
                              }
                            else if (item?.value === "created_at") {
                                return <td>
                                    <div
                                        className="ml-2"
                                        style={{
                                            display: "flex",
                                            justifyContent: "left",
                                            alignItems: "center",
                                            gap: "7px",
                                        }}
                                    >
                                        <div style={{ marginTop: "-16px" }}>
                                            <CircularAvatar
                                                name={itemData?.updated_by_name}
                                                image={
                                                    itemData?.updated_by_profile_pic &&
                                                    itemData?.updated_by_profile_pic?.file_url
                                                }
                                            />
                                        </div>
                                        <div
                                        >
                                            <span>
                                                {itemData?.updated_by_name}
                                            </span>
                                            <p style={{ color: "#6e7491" }}>{formateDateTime(itemData?.updated_at)}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            }
                            else {
                                <td>{itemData[item?.value]}</td>
                            }
                        })
                    }
                    <td style={{ width: '50px', textAlign: 'start' }}>
                        <div className='d-flex'>
                            {isClientGroupEditButtonPresent &&  
                            <span className="d-inline-block pointer"
                            >
                                <div style={{
                                    color: '#d43',
                                    fontSize: 20,
                                    width: '30px',
                                }}>
                                    <img onClick={() => handleEditMasterClientGroup?.(itemData)} src={tableEditIcon} alt='' />
                                </div>
                            </span>
                         } 
                        </div>
                    </td>
                </tr>
            })
        }
        </>
    )
}

export default ClientGroupTableData